import { createContext, useContext } from 'react';
const CommandMenuItemsImplementationContext = createContext(undefined);
export const CommandMenuItemsImplementationProvider = CommandMenuItemsImplementationContext.Provider;
export function useCommandMenuItemsImplementation() {
    return useContext(CommandMenuItemsImplementationContext);
}
//# sourceMappingURL=commandMenuItemsImplementationShared.js.map